import { render, staticRenderFns } from "./ServiceDetailDestinations.vue?vue&type=template&id=814ca8c2&scoped=true&"
import script from "./ServiceDetailDestinations.vue?vue&type=script&lang=js&"
export * from "./ServiceDetailDestinations.vue?vue&type=script&lang=js&"
import style0 from "./ServiceDetailDestinations.vue?vue&type=style&index=0&id=814ca8c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "814ca8c2",
  null
  
)

export default component.exports